export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const UPDATE = "UPDATE";
export const PROJECT_UPDATE = "PROJECT_UPDATE";
export const LOADING = "LOADING";
